export const FIELD_INFO_FALLBACKS: { [gridName: string]: { [fieldKeyName: string]: string } } = {
  'Project': {
    name: 'The name of this project.',
    organizationName: 'The organization this project belongs to.',
    matterName: 'The matter this project falls under.',
    projectTemplateId: 'The template this project was created from.',
    projectTypeId: 'The type of project.',
    statusCode: 'Where the project sits in the workflow.',
    priorityCode: 'This project’s priority relative to others.',
    dueDate: 'When the project and all its tasks must be completed.',
    startDate: 'When work on this project begins.',
    closedDate: 'Set automatically when the project completes.',
    lpcUserId: 'The Legal Project Coordinator responsible for this project.',
    requestedBy: 'Who requested this project.',
    description: 'What work this project covers.',
    notes: 'Internal notes. Not shown to the client.',
    taskName: 'The tasks belonging to this project.',
    isBillable: 'Whether this work can be billed to the client.',
    nonBillableReason: 'Required when Billable is No.',
    isEnforceEstimatedTime: 'Holds timekeepers to the estimated time on this project’s tasks.',
    estimatedTime: 'Total time estimated, rolled up from tasks.',
    actualTime: 'Total time recorded so far.',
    estimatedBudget: 'The budget estimated for this project.',
    actualSpend: 'The amount spent so far.',
    holdTimeUntilCompleted: 'Holds time and disbursements from export until the project completes.',
    isPreInvoiced: 'Invoiced before the work was completed.',
    invoiceNumber: 'The invoice number for this project.',
    isInvoicePaid: 'Whether the invoice has been paid.'
  },
  'Project Task': {
    taskName: 'The name of this task, taken from the Task Catalogue. Locked once the task exists.',
    projectName: 'The project this task belongs to.',
    taskTypeCode: 'The catalogue task type. Disbursements tasks show the payment fields instead of billing and classification.',
    practiceAreaCode: 'The practice area this task falls under. Set by the catalogue.',
    statusCode: 'Where the task sits in the workflow. It moves through the workflow actions, not by editing this field.',
    isCompleted: 'Marks the task finished. Enabled once the status is Approved; for Disbursements tasks, also when the status is Ready to Complete.',
    taskDueDate: 'When the task is due. Must fall between the task created date and the project due date.',
    reviewStatus: 'What the task is waiting on — client, agency, payment or Secretary of State.',
    approver: 'The LPC who approves this task. One approver per task.',
    dueDaySlot: 'The part of the day the task is due: morning, afternoon or evening.',
    description: 'Free-text detail about the work this task covers.',
    taskInstructions: 'Instructions authored in the Task Catalogue. Read-only here.',
    driveLink: 'Link to the OneDrive or SharePoint location holding this task’s documents.',
    actualTime: 'Total time logged against this task, summed from its time records.',
    timeEstimate: 'Estimated time for this task, set by the catalogue or the estimate flow.',
    maxTime: 'The ceiling on time that can be logged. Applies only when Enforced Max Time is Yes, and is skipped when Open Ended is Yes.',
    progress: 'Share of the estimate consumed — time logged divided by estimated time. This is consumption, not completion.',
    rateTypeCode: 'The billing rate type from the catalogue. Fixed Rate changes how consolidated time records behave.',
    isEnforceMaximum: 'Whether Max Time is enforced for this task.',
    catEnforceMax: 'The enforced-maximum setting inherited from the Task Catalogue.',
    isBillable: 'Whether time logged on this task can be billed. Locked once the task is pre-invoiced or pre-paid.',
    nonBillableReason: 'Why the task is not billable. Required when Billable is No.',
    consolidatedTimeRecords: 'Combines this task’s time records into one entry. Setting this to Yes forces Hold Time Until Completed to Yes.',
    isRequireEstimate: 'Whether this task is flagged as requiring an estimate. Recorded on the task; not enforced when the task is accepted.',
    isApprovalRequired: 'Whether the task must be approved before it can be completed.',
    openEnded: 'The task has no time ceiling — max-time checks are skipped. A due date is still required.',
    holdTimeUntilComp: 'Holds this task’s time records until the task is completed.',
    isPreInvoiced: 'Set by the billing pipeline once the task has been invoiced. Locks Billable.',
    isPrePaid: 'Set by the billing pipeline once the task has been paid. Locks Billable.',
    disbursementRelated: 'Whether this task can have disbursement tasks attached to it. Controls Manage Disbursement Tasks.',
    countryRelated: 'Whether a country has to be recorded for this task.',
    isStateRelated: 'Whether a state has to be recorded for this task.',
    country: 'The jurisdiction country. This decides which states are offered.',
    stateCode: 'The jurisdiction state. Options follow the selected country.',
    quantityType: 'Whether Quantity is a list of states or a plain number.',
    quantityState: 'The states this task covers. Select one or more.',
    quantityNumber: 'How many items this task covers.',
    tkRating: 'The LPC’s rating of the timekeeper’s work on this task, from 1 to 5.',
    entityId: 'The entity this task relates to.',
    transactionType: 'How the disbursement is paid. Escrow requires an escrow client; Credit Card on File clears the payment method.',
    paymentMethod: 'The account the disbursement is paid from.',
    escrowAccountId: 'The escrow client the disbursement is paid from. Required for escrow transactions.',
    payee: 'Who is being paid.',
    payeeInvoiceNumber: 'The payee’s invoice number for this disbursement.',
    paymentReferenceNumber: 'The reference number recorded against the payment.',
    receipt: 'Whether a receipt was received for this disbursement.',
    disbursementAmount: 'The amount to be paid for this disbursement task.',
    datePaid: 'The date the disbursement was paid. Cannot be a future date.',
    notes: 'Task-level internal instructions. Distinct from project notes, catalogue instructions and comments.'
  }
};
